import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { XCircle, ArrowLeft, Crown } from 'lucide-react';

const SubscriptionCanceled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <XCircle className="w-10 h-10 text-gray-500" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Subscription Canceled</h2>
        <p className="text-gray-600 mb-6">
          No worries! Your subscription upgrade was canceled and no payment was processed.
        </p>
        
        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-center mb-2">
            <Crown className="w-5 h-5 text-blue-600 mr-2" />
            <span className="font-semibold text-blue-800">You're Missing Out On</span>
          </div>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>✨ Unlimited AI chat with Lexi</li>
          </ul>
          <div className="mt-3 text-xs text-blue-600">
            All for just <strong>$1.99/month</strong>
          </div>
        </div>
        
        <div className="space-y-3">
          <button
            onClick={() => navigate('/subscription')}
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-3 px-4 rounded-lg font-medium transition-colors"
          >
            Try Pro Again
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-800 py-3 px-4 rounded-lg font-medium transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="mr-2 w-4 h-4" />
            Back to Dashboard
          </button>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            Questions about Pro features? <Link to="/help" className="text-purple-600 hover:underline">Contact us</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCanceled;